var _defs, _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlowers01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fcdad8;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_43",
    "data-name": "Group 43"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_14",
    "data-name": "Rectangle 14",
    className: "cls-1",
    d: "M118.32,41.59h0a137.9,137.9,0,0,1,76.2,179.52h0l-2.07,5.12h0a137.91,137.91,0,0,1-76.2-179.52l2.07-5.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_15",
    "data-name": "Rectangle 15",
    className: "cls-1",
    d: "M354.78,137.13h0l-2.07,5.11a137.9,137.9,0,0,1-179.52,76.2h0l2.07-5.11a137.9,137.9,0,0,1,179.52-76.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_14-2",
    "data-name": "Rectangle 14-2",
    className: "cls-1",
    d: "M205,195.2h0l-2.07,5.11A137.9,137.9,0,0,1,23.4,276.52h0l2.07-5.12A137.91,137.91,0,0,1,205,195.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_15-2",
    "data-name": "Rectangle 15-2",
    className: "cls-1",
    d: "M185.73,187.42h0a137.9,137.9,0,0,1,76.2,179.52h0l-2.07,5.11h0a137.9,137.9,0,0,1-76.2-179.52l2.07-5.11Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlowers01);
export default __webpack_public_path__ + "static/media/flowers-01.c6c3aa8fcabeb56c79ce9e80ca3131d4.svg";
export { ForwardRef as ReactComponent };